import React from 'react';
import { BarChart3Icon, BoxesIcon, CreditCardIcon, HomeIcon, LandmarkIcon, ReceiptIcon, ShoppingCartIcon, UsersIcon } from 'lucide-react';
import { MockCardView } from './MockCardView';
import type { DashboardSpec, MockCard, Tone } from '../../../types/product';
const modules = [{
  label: 'Home',
  icon: HomeIcon
}, {
  label: 'Sales',
  icon: CreditCardIcon
}, {
  label: 'Inventory',
  icon: BoxesIcon
}, {
  label: 'Purchases',
  icon: ShoppingCartIcon
}, {
  label: 'Expenses',
  icon: ReceiptIcon
}, {
  label: 'Customers',
  icon: UsersIcon
}, {
  label: 'Reports',
  icon: BarChart3Icon
}, {
  label: 'Finance',
  icon: LandmarkIcon
}];
const deltaTone: Record<Tone, string> = {
  default: 'text-ink-muted',
  positive: 'text-[#1B7A3D]',
  negative: 'text-[#C0362C]',
  warning: 'text-[#9A5B15]',
  brand: 'text-brand'
};
type DevicesCompositeProps = {
  tablet: DashboardSpec;
  phone: MockCard;
};
export function DevicesComposite({
  tablet,
  phone
}: DevicesCompositeProps) {
  return <div className="relative mx-auto w-full max-w-[620px] pb-10 pr-6 sm:pr-10" data-id="element-1081" data-mp="1vnk40yqgxkbg">
      <div className="rounded-[26px] bg-[#1A1A1A] p-[10px] shadow-[0_40px_80px_-40px_rgba(11,11,11,0.55)]" data-id="element-1082" data-mp="1qo78zqpg16xs">
        <div className="grid aspect-[4/3] grid-cols-[52px_1fr] overflow-hidden rounded-[17px] bg-[#F7F7F6]" data-id="element-1083" data-mp="1lobgooq3z3y2">
          <nav aria-hidden="true" className="flex flex-col items-center gap-1.5 border-r border-canvas-line bg-white py-3" data-id="element-1084" data-mp="1gqjen1vr21g5">
            <img src="https://cdn.magicpatterns.com/uploads/5i6MtaXtJgiVKKtHh9W13p/kayko_favicon_transparent_(1).svg" alt="" className="mb-2 h-4 w-4" data-id="element-1085" data-mp="1coy2jir1hr70" />
            {modules.map(m => {
            const Icon = m.icon;
            const active = m.label === tablet.module;
            return <span key={m.label} className="flex flex-col items-center gap-0.5" data-id="element-1086" data-mp="szxgq3fglxjv">
                  <span className={`flex h-6 w-6 items-center justify-center rounded-[6px] ${active ? 'bg-brand-soft text-brand' : 'text-ink-muted'}`} data-id="element-1087" data-mp="oykb9uga3wdh">
                    <Icon className="h-3 w-3" data-id="element-1088" data-mp="jctgkd4ahuqq" />
                  </span>
                  <span className={`text-[6px] ${active ? 'font-semibold text-brand' : 'text-ink-muted'}`} data-id="element-1089" data-mp="5d1xvz2tvq6e">{m.label}</span>
                </span>;
          })}
          </nav>
          <div className="flex min-w-0 flex-col gap-2 p-3" data-id="element-1090" data-mp="y1fxgj9keuk2">
            <p className="text-[11px] font-semibold text-ink" data-id="element-1091" data-mp="y1zhc5irzt0q">{tablet.greeting}</p>
            <div className="grid grid-cols-3 gap-2" data-id="element-1092" data-mp="121zulmu51y67">
              {tablet.kpis.map(k => <div key={k.label} className="rounded-[9px] bg-white p-2 ring-1 ring-canvas-line" data-id="element-1093" data-mp="oalblg08dwz5">
                  <p className="truncate text-[7.5px] text-ink-muted" data-id="element-1094" data-mp="t9pk04fbzqof">{k.label}</p>
                  <p className="mt-0.5 truncate text-[10.5px] font-semibold text-ink" data-id="element-1095" data-mp="1gzsawh7ieqlg">{k.value}</p>
                  {k.delta && <p className={`text-[7px] font-medium ${deltaTone[k.delta.tone]}`} data-id="element-1096" data-mp="1ls3js9k89mq5">{k.delta.label}</p>}
                </div>)}
            </div>
            <div className="grid min-h-0 flex-1 grid-cols-[1.25fr_1fr] gap-2 overflow-hidden" data-id="element-1097" data-mp="1r48mgydyhljg">
              <div className="min-w-0 overflow-hidden" data-id="element-1098" data-mp="1r2fnm59l45m0">
                <MockCardView card={tablet.main} size="sm" flat data-id="element-1099" data-mp="24uc4fd5syt33" />
              </div>
              <div className="min-w-0 overflow-hidden" data-id="element-1100" data-mp="1zxlnyoq35vh5">
                <MockCardView card={tablet.side} size="sm" flat data-id="element-1101" data-mp="1zywtou33ddaw" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 right-0 w-[190px] origin-bottom-right scale-[0.78] sm:scale-100" data-id="element-1102" data-mp="186fw0vkir42y">
        <div className="rounded-[30px] bg-[#1A1A1A] p-[7px] shadow-[0_30px_60px_-24px_rgba(11,11,11,0.55)]" data-id="element-1103" data-mp="1m5yqilkeqgws">
          <div className="overflow-hidden rounded-[24px] bg-[#F7F7F6] px-2 pb-3 pt-5" data-id="element-1104" data-mp="1h4hr6uhkn2ib">
            <div className="mx-auto mb-2.5 h-1 w-10 rounded-full bg-canvas-line" data-id="element-1105" data-mp="2xj173gmib6gy" />
            <MockCardView card={phone} size="sm" flat data-id="element-1106" data-mp="2sm0z3063jtn7" />
          </div>
        </div>
      </div>
    </div>;
}